import { render } from "./OrgProfileManageAdmins.vue?vue&type=template&id=03633429&scoped=true"
import script from "./OrgProfileManageAdmins.vue?vue&type=script&lang=js"
export * from "./OrgProfileManageAdmins.vue?vue&type=script&lang=js"

import "./OrgProfileManageAdmins.vue?vue&type=style&index=0&id=03633429&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03633429"]])

export default __exports__